import type { PlatformServices, StorageService, UpdateService, KioskService, AppService, WOLService } from './types';

const electronStorage: StorageService = {
  get: (key) => window.electron!.storage.get(key),
  set: (key, value) => window.electron!.storage.set(key, value),
  remove: (key) => window.electron!.storage.remove(key),
};

const electronUpdate: UpdateService = {
  getVersion: () => window.electron!.update.getVersion(),
  check: () => window.electron!.update.check(),
  install: (url, name, id) => window.electron!.update.install(url, name, id),
};

const electronKiosk: KioskService = {
  lock: () => window.electron!.lockKiosk(),
  getStatus: () => window.electron!.getKioskStatus(),
  onStatusChange: (cb) => window.electron!.onKioskStatus(cb),
  onShowUnlock: (cb) => window.electron!.onShowAdminUnlock(cb),
  unlockAdmin: (pw) => window.electron!.unlockAdmin(pw),
  onUnlockResult: (cb) => window.electron!.onAdminUnlockResult(cb),
};

const electronApp: AppService = {
  quit: () => window.electron!.quitApp(),
};

const electronWOL: WOLService = {
  send: (mac, ip) => window.electron!.sendWOL(mac, ip),
};

export function createElectronServices(): PlatformServices {
  return {
    storage: electronStorage,
    update: electronUpdate,
    kiosk: electronKiosk,
    app: electronApp,
    wol: electronWOL,
  };
}
